import { Col, FormGroup, Form, Row } from "react-bootstrap";
import {ErrorText} from "../../../../../@ui/ErrorText";
import FileUploader from "../../../../../@ui/FileUploader";

interface NcsdImportFieldsProps {
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  errors: any;
  ncsdTouched: boolean;
  setNcsdTouched: (touched: boolean) => void;
}

const NcsdImportFields = ({
  setFieldValue,
  errors,
  ncsdTouched,
  setNcsdTouched,
}: NcsdImportFieldsProps) => {
  return (
    <Row className="justify-content-center">
      <Col className="col-md-10">
        <FormGroup className="w-100 mt-2">
          <Form.Label>Upload NCSD File: </Form.Label>
          <FileUploader
            onClear={() => setFieldValue("ncsdFile", undefined)}
            onChange={(file: any) => {
              setFieldValue("ncsdFile", file);
            }}
            onBlur={(_) => setNcsdTouched(true)}
          />
        </FormGroup>
        {errors.ncsdFile && ncsdTouched && (
          <ErrorText className="text-danger">NCSD file is required</ErrorText>
        )}
      </Col>
    </Row>
  );
};

export default NcsdImportFields;
